/**
* Utc.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
export var HASH_IDENTIFIERS_FLAG = 0x100000;
export var DROP_IDENTIFIERS_FLAG = 0x200000;
var strEventFlags = "eventFlags";
var Utc = /** @class */ (function () {
    function Utc(propertiesConfig) {
        var self = this;
        self.popSample = 100;
        self[strEventFlags] = 0;
        if (propertiesConfig.hashIdentifiers) {
            self[strEventFlags] = self[strEventFlags] | HASH_IDENTIFIERS_FLAG;
        }
        if (propertiesConfig.dropIdentifiers) {
            self[strEventFlags] = self[strEventFlags] | DROP_IDENTIFIERS_FLAG;
        }
    }
    return Utc;
}());
export { Utc };
//# sourceMappingURL=Utc.js.map